import { Leaf, Sprout, Flame, WheatOff, Star, Sparkles } from "lucide-react";
import type { Tag } from "../../types/menu";
import type { LucideIcon } from "lucide-react";

interface BadgeProps {
  tag: Tag;
}

const tagConfig: Record<
  Tag,
  { label: string; icon: LucideIcon; className: string }
> = {
  vegetariano: {
    label: "Vegetariano",
    icon: Leaf,
    className: "bg-green-100 text-green-800 border border-green-200",
  },
  vegano: {
    label: "Vegano",
    icon: Sprout,
    className: "bg-emerald-100 text-emerald-800 border border-emerald-200",
  },
  picante: {
    label: "Picante",
    icon: Flame,
    className: "bg-red-100 text-red-800 border border-red-200",
  },
  "sin-gluten": {
    label: "Sin Gluten",
    icon: WheatOff,
    className: "bg-amber-100 text-amber-800 border border-amber-200",
  },
  popular: {
    label: "Popular",
    icon: Star,
    className: "bg-primary/10 text-primary border border-primary/25",
  },
  nuevo: {
    label: "Nuevo",
    icon: Sparkles,
    className: "bg-ocean/10 text-ocean border border-ocean/25",
  },
};

export default function Badge({ tag }: BadgeProps) {
  const { label, icon: Icon, className } = tagConfig[tag];
  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold ${className}`}
    >
      <Icon className="w-3 h-3" />
      {label}
    </span>
  );
}
